import tw from 'tailwind-styled-components'

interface SearchInputProps {
  $width: string
  $height: string
}
export const SearchInput = tw.input<SearchInputProps>`
 bg-chineseBlack text-white p-15 rounded-4 text-xs focus:ring-1 focus:ring-eucalyptus focus:outline-none placeholder-white h-50

 ${({ $width }) => ($width ? $width : '')}
 ${({ $height }) => ($height ? $height : '')}
`

export const SearchIconWrap = tw.button`
  absolute top-20 right-16 transform -translate-y-1/2 w-20 h-20 md:w-24 md:h-24 text-white
`

export const SearchWrap = tw.div`
    relative w-fit
`
